import { Action } from '@lib/plugin-redux-core';
import {
  FormRelease,
  QuestionRelease,
  QuestionReleaseProps,
  QuestionReleases,
  SectionSummary,
} from '@module/form';
import { AssignmentReviewPageState } from './assignment-review.reducer';

export const handleFindSectionSummariesUseCase = {
  executing: (state: AssignmentReviewPageState): AssignmentReviewPageState => {
    return { ...state, isLoadSectionSummaries: true };
  },
  success: (state: AssignmentReviewPageState, action: Action): AssignmentReviewPageState => {
    const { payload } = action;
    const sectionSummaries = payload as SectionSummary[];

    return {
      ...state,
      sectionSummaries,
      isLoadSectionSummaries: false,
    };
  },
  error: (state: AssignmentReviewPageState, action: Action): AssignmentReviewPageState => {
    const { error } = action;
    return {
      ...state,
      error,
      isLoadSectionSummaries: false,
    };
  },
};

export const handleFindFormReleaseByIdUseCase = {
  executing: (state: AssignmentReviewPageState): AssignmentReviewPageState => {
    return { ...state, isLoadingFindForm: true };
  },
  success: (state: AssignmentReviewPageState, action: Action): AssignmentReviewPageState => {
    const { payload } = action;
    const formReleaseResponse = payload as FormRelease;
    const defaultSelectedSectionIndex = 0;

    return {
      ...state,
      formReleaseResponse,
      selectedSection: formReleaseResponse.sections[defaultSelectedSectionIndex],
      selectedSectionIndex: defaultSelectedSectionIndex,
      isLoadingFindForm: false,
    };
  },
  error: (state: AssignmentReviewPageState, action: Action): AssignmentReviewPageState => {
    const { error } = action;
    return {
      ...state,
      error,
      isLoadingFindForm: false,
    };
  },
};

export const handleFindAllQuestionsReleaseUseCase = {
  executing: (state: AssignmentReviewPageState): AssignmentReviewPageState => {
    return { ...state, isLoadingFindQuestions: true };
  },
  success: (state: AssignmentReviewPageState, action: Action): AssignmentReviewPageState => {
    const { payload } = action;
    const questions = payload as QuestionRelease<QuestionReleaseProps>[];
    const sortedQuestionsWithSectionsOrder = QuestionReleases.sortQuestionsBySectionsOrder(
      questions,
      state.formReleaseResponse?.sections as SectionSummary[],
    );
    const sortedQuestions = QuestionReleases.sortQuestionsWithIndexAndSection(
      sortedQuestionsWithSectionsOrder,
    );
    return {
      ...state,
      questions: sortedQuestions,
      isLoadingFindQuestions: false,
    };
  },
  error: (state: AssignmentReviewPageState, action: Action): AssignmentReviewPageState => {
    const { error } = action;
    return {
      ...state,
      error,
      isLoadingFindQuestions: false,
    };
  },
};

export const handleChangeSelectedSection = {
  executing: (state: AssignmentReviewPageState, action: Action): AssignmentReviewPageState => {
    const { payload } = action;
    const selectedSectionIndex = state.formReleaseResponse?.sections?.findIndex(
      (s) => s.id.toString() === payload.selectedSection?.id.toString(),
    );
    return {
      ...state,
      selectedSection: payload.selectedSection as SectionSummary,
      selectedSectionIndex,
    };
  },
};
